import { Search } from '@mui/icons-material'
import { ButtonBase, Checkbox, Pagination } from '@mui/material'
import { MouseEvent, useState } from 'react'
import { BsTrash } from 'react-icons/bs'
import { ITableProps } from '../../../../../shared/types'
import Select from '../../../../organisms/Select'

export default function Table({title,tableHeadData, tableBodyData, handleItemClick=()=>{}}:ITableProps) {

    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] =useState(5)
    const [selectedItems, setSelectedItems] = useState<string[]>([])

    const handleOnHeaderBoxCheck = (e:MouseEvent<HTMLButtonElement, globalThis.MouseEvent | MouseEvent>)=>{
        e.stopPropagation()

        if((selectedItems.length < tableBodyData.length && selectedItems.length > 0) || selectedItems.length === 0){

            const _selectedItems:string[] = []
            tableBodyData.forEach((data)=>{
                _selectedItems.push(data.name)
            })
            setSelectedItems(_selectedItems)        

        }else if(selectedItems.length === tableBodyData.length){
            setSelectedItems([])
        }
    }
    
    const handleOnItemsCheck = (e:MouseEvent<HTMLButtonElement, globalThis.MouseEvent|MouseEvent>, item:string)=>{
        e.stopPropagation()

        const _selectedItems = [...selectedItems]
        
        if(_selectedItems.includes(item)){
            setSelectedItems(_selectedItems.filter((selected)=>selected !== item))
        }else{
            _selectedItems.push(item)
            setSelectedItems(_selectedItems)
        }
        
    }
    
  return (
    <div
        className='w-full h-full text-secondary2 '
    >
        <div className="flex w-full justify-between items-center mb-4">
            <label className="bg-blue-500/20 py-2 px-4 rounded border border-blue-500/60">
                {title}
            </label>

            <div className='flex'>
                <div className='flex justify-center items-center py-1 border-b border-b-gray-600'>
                    <Search fontSize="small" className='text-gray-600' />
                    <input 
                        placeholder='...search' 
                        className='bg-white/0 focus:outline-none'
                    />
                </div>
                {
                    selectedItems.length > 0 && (
                        <div className="ml-4 w-9 h-9 flex justify-center items-center border border-red-600/50 rounded bg-red-600">
                            <ButtonBase title='Delete' sx={{width: "100%", height: "100%"}}>
                                <BsTrash className='text-white' />
                            </ButtonBase>
                        </div>
                    )
                }
            </div>
        </div>
        
        <table className='w-full block '>

            <thead className='w-full block'>
                <tr className='py-4 w-full flex justify-center items-center text-left border-b-2 border-b-gray-600 text-ellipsis ' >
                    <th>
                        <Checkbox 
                            sx={{
                                color: 'primary.light',
                                '&.Mui-checked':{
                                    color: 'secondary.main'
                                },
                                '&.MuiCheckbox-indeterminate':{
                                    color: 'secondary.main'
                                },
                            }}
                            checked={(selectedItems.length === tableBodyData.length) && tableBodyData.length > 0}
                            indeterminate={selectedItems.length < tableBodyData.length && selectedItems.length > 0}
                            onClick={handleOnHeaderBoxCheck}
                        />
                    </th>
                    {
                        tableHeadData.map((headData, index)=>(
                            <th key={index} className='block flex-1 overflow-hidden'>
                                <p
                                    className='w-48 truncate overflow-hidden'
                                >
                                    {headData}
                                </p>
                            </th>
                        ))
                    }
                </tr>
            </thead>
            <tbody className='text-gray-400 block w-full'>
                {
                    tableBodyData.slice((currentPage-1)*itemsPerPage, itemsPerPage*currentPage).map((data, index)=>(

                        <tr 
                            key={index} 
                            className='cursor-pointer py-2 w-full flex justify-center items-center text-left border-b border-b-white/20'
                            onClick={()=>{
                                handleItemClick(data)
                            }}
                        >
                            <td>
                                <Checkbox 
                                    sx={{
                                        color: 'primary.light',
                                        '&.Mui-checked':{
                                            color: 'secondary.main'
                                        }
                                    }}
                                    checked={selectedItems.includes(data.name)}
                                    onClick={(e)=>handleOnItemsCheck(e, data.name)}
                                />
                            </td>
                            <td className='flex-1 pr-1'>
                            <p
                                    className='w-48 truncate overflow-hidden'
                                >
                                    {data.name}
                            </p>
                            </td>
                            <td className='flex-1'>{data.purchased}</td>
                            <td className='flex-1'>{data.sold}</td>
                            <td className='flex-1'>{data.inStock}</td>
                            <td className='flex-1'>{data.valuation}</td>
                            <td className='flex-1'>{data.expectedRevenue}</td>
                            {/* <td className='flex-1'>{data.daysToExpire}</td> */}
                        </tr>
                        
                    ))
                } 
                
            </tbody>
            
        </table>

        <div className="mt-8 flex flex-row-reverse">

            <Pagination 
                shape='rounded'
                variant='outlined'
                count={Math.round(tableBodyData.length/itemsPerPage)}
                page={currentPage}
                color="secondary"
                onChange={(e, value)=>setCurrentPage(value)}
            />

            <div className="flex justify-center items-center">
                Items per page: &nbsp;
                <Select
                    data={[
                        {value:5, label: "Five"},
                        {value:10, label: "Ten"},
                        {value:15, label: "Fifteen"},
                    ]}
                    // title="Rows per page"
                    value={itemsPerPage}
                    onChange={(value)=>setItemsPerPage(parseInt(value))}
                />
            </div>

            
        </div>
        
    </div>
  )
}